import Pagination from "components/CommonForBoth/Pagination";
import { useState } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
// import { CheckCircleOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { setAgentToChat } from "store/auth/agent/agentSlice";
import ContactAgentButton from "./ContactAgentButton";

const AgentsList = ({ agents, formatDate }) => {
    // const dispatch = useDispatch();
    const limit = 4;

    const [currentPage, setCurrentPage] = useState(0);
    const [skip, setSkip] = useState(0);

    const totalAgents = agents ? agents.length : 0;
    const totalPages = Math.ceil(totalAgents / limit);
    const paginationItems = [...Array(totalPages)];

    const agentsToShow = agents
        ? agents.slice(skip, skip + limit)
        : [];


    const handlePagination = (id) => {
        if (typeof id === "number") {
            setCurrentPage(id);
            setSkip(limit * id);
        } else if (id === "prev" && currentPage > 0) {
            setCurrentPage(currentPage - 1);
            setSkip(skip - limit);
        } else if (id === "next" && currentPage < totalPages - 1) {
            setCurrentPage(currentPage + 1);
            setSkip(skip + limit);
        }
    };

    return (
        <>
            {totalAgents > 0 ? (
                <>
                    {agentsToShow?.map((agent) => (
                        <Row key={agent?._id} className="mb-3">
                            <Col sm={12}>
                                <Card
                                    className="shadow-sm transition-hover"
                                    style={{
                                        cursor: "pointer",
                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.transform = "translateY(-3px)";
                                        e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.1)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.transform = "none";
                                        e.currentTarget.style.boxShadow = "";
                                    }}
                                >
                                    <CardBody>
                                        <Row className="align-items-center">
                                            <Col md={8}>
                                                <h4 className="fw-bold me-2">
                                                    {agent?.firstName} {agent?.lastName}
                                                </h4>

                                                <small className="text-muted">
                                                    {formatDate(agent?.createdAt)}
                                                </small>
                                            </Col>
                                            <Col md={4} className="text-end">
                                                {/* Affichage du prénom et du nom à droite */}
                                                <span className="fw-bold mb-1">{agent?.companyName}</span>
                                                {/* <img
                                                    src={agent.licenseDocument}
                                                    alt={agent.companyName}
                                                    style={{ width: 32, height: 32, objectFit: "contain" }}
                                                /> */}
                                            </Col>
                                        </Row>
                                        <br />
                                        <Row className="mb-3">
                                            <Col md={5}>
                                                <p className="mb-1">
                                                    <strong>Email :</strong> {agent?.email}
                                                </p>
                                                <p className="mb-1">
                                                    <strong>Téléphone :</strong> {agent?.phone}
                                                </p>
                                                <p className="mb-1">
                                                    <strong>Numéro de licence :</strong> {agent?.licenseNumber}
                                                </p>
                                            </Col>
                                            <Col md={7}>
                                                {/* <p className="mb-1">
                                                    <strong>Informations complémentaires</strong>
                                                </p> */}
                                            </Col>
                                        </Row>
                                        <Row className="align-items-end">
                                            <Col md={8}>
                                            </Col>
                                            <Col md={4} className="text-end">
                                                <Link to={!agent?.initiatedByAgent ? null : "/chat/" + agent?._id}>
                                                    {/* <Button
                                                        color="primary"
                                                        className="px-5"
                                                        disabled={!agent?.initiatedByAgent}
                                                        onClick={() => dispatch(setAgentToChat(agent))}
                                                    >
                                                        Contacter
                                                    </Button> */}
                                                    <ContactAgentButton agent={agent} />
                                                </Link>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>


                    ))}
                    <div style={{ width: "fit-content", margin: "0 auto" }}>
                        <Pagination
                            pages={paginationItems}
                            totalItems={totalAgents}
                            handlePagesnation={handlePagination}
                            currentPage={currentPage}
                            limit={limit}
                        />
                    </div>


                </>
            ) : (
                <Row>
                    <Col>
                        <div className="text-center p-5">
                            <h4>Aucun agent disponible</h4>
                        </div>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default AgentsList;
